<!--  -->
<template>
  <div class="shared-hotel-nav-bar" :style="[style_bgc, style_bg, style_fixed,style_height,style_box]">
    <div class="left" :style="{ color: fontColor }" @click="leftBack">
      <!-- <van-icon name="arrow-left" :style="{ color: fontColor }" /> -->
      <!-- <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAkBAMAAAAaxSXRAAAAFVBMVEUAAAATFRUTFRUSFBQSFRUTExYTFBVuIh2DAAAABnRSTlMArohxY1IX2rJpAAAAM0lEQVQoz2PACZgN0ATEUlD5jGmpaArSFNAUJA0DBcwIBQgB/FoYGIehklS8yQGRYDABABbZFn1qi6llAAAAAElFTkSuQmCC" 
        :style="{ color: fontColor }"
      /> -->
      <img
        src="../../../assets/shared-hotel/leftBack.png" 
        :style="{ color: fontColor }"
        v-if="! whiteBack"
      />
      <img
        src="../../../assets/shared-hotel/leftBack-white.png" 
        :style="{ color: fontColor }"
        v-if="whiteBack"
      />
    </div>
    <div
      class="title"
      :style="{ color: fontColor,fontWeight:titleWeight }"
      v-show="titleText&&!issearch"
    >{{ titleText }}</div>
   
    <slot name="default" v-show="!issearch">
      <div
        class="right"
        :style="{ color: rigthFontColor,fontWeight:rightWeight,fontSize:rightSize }"
        v-if="rightText"
        @click="rightTextEvent"
      >{{ rightText }}</div>
    </slot>
     <div class="top-search-div" v-show="issearch">
        <input v-model="searchvalue" placeholder="请输入店铺名称" @focus="goDeatilSearch" :style="client==11?'width: calc(100% - 15px);':''"/>
        <div class="search-icon" :style="client==11?'top:14px;':'top:32%;'"><img src="../../../assets/shared-hotel/search.png" /></div>
        <div :class="client==11?'search-btns':'search-btn'">搜索</div>
    </div>
    <div class="condition" v-show="issearchs">
            <div
            v-for="(item, i) in selectedList"
            :key="i"
            class="tag"
            :class="{'tag-active': item.selected}"
            @click="clickCondition(item)"
            >{{ item.text }}</div>
      </div>
  </div>
</template>

<script>
export default {
  name: "navBar",
  data() {
    return {
        selectedList: [
        {text: '距离最近', selected: true},
        {text: '充值最优惠', selected: false},
        {text: '可充值额度最高', selected: false},
      ],
      searchvalue:'',
      isIOS:false,
      client:0
    };
  },
  props: {
    titleText: {
      type: String,
    },
    rightText: {
      type: String,
    },
    fontColor: {
      type: String,
      defult: "#ffffff",
    },
    rigthFontColor: {
      type: String,
      defult: "#ffffff",
    },
    titleWeight: {
      type: String,
      defult: "none",
    },
    rightWeight: {
      type: String,
      defult: "none",
    },
    rightSize: {
      type: String,
      defult: "14px",
    },
    bgc: {
      type: String,
    },
    bg: {
      type: String,
    },
    isFixed: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
    },
    whiteBack: {
      type: Boolean,
    },
    issearch:{
      type: Boolean,
      default: false,
    },
    issearchs:{
      type: Boolean,
      default: false,
    },
    boxShadow:{
        type:String
    }
  },
  computed: {
    style_bgc: function () {
      return {
        "background-color": this.bgc,
      };
    },
    style_bg: function () {
      return {
        background: this.bg,
      };
    },
    style_fixed: function () {
      return this.isFixed
        ? {
            position: "fixed",
            top: 0,
            "z-index": 100,
            padding: "44px 0 0",
          }
        : {};
    },
    style_height: function () {
      return {
        height: this.height,
      };
    },
    style_box:function(){
        return{
            "box-shadow":this.boxShadow
        }
    }
  },
  created(){
    // this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    this.deductionUA()
  },
  methods: {
    deductionUA() {
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.client = 11
      } else if (/android/.test(ua)) {
        this.client = 10
      }
    },
    leftBack() {
      this.$emit("goBack");
    },
    rightTextEvent() {
      this.$emit("rightTextEvent");
    },
    clickCondition(item){
      this.$emit("clickCondition",item);
    },
    //前往店铺详情搜索界面
    goDeatilSearch() {
        this.$emit("goDeatilSearch");
    },
  },
};
</script>

<style scoped lang='less'>
.shared-hotel-nav-bar {
  width: 100%;
  background: #fff;
  height: 44px;
  padding: 44px 0 0px;
  line-height: 44px;
  position: relative;
  .left {
    width: 24px;
    height: 24px;
    line-height: 24px;
    display: inline-block;
    position: absolute;
    top: 55px;
    margin: 0 12px 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
  .right {
    position: absolute;
    right: 0;
    margin: 0 16px;
    top: 52px;
    height: 29px;
    line-height: 29px;
  }
  .top-search-div {
  display: block;
  width: calc(100% - 50px);
  margin-left: 40px;
  margin-bottom: 0px;
  padding-top: 6px;
  padding-bottom: 6px;
  box-sizing: border-box;
  position: relative;
  top:-5px;
  input::-webkit-input-placeholder{
    color: #999999;
}
  input {
    height: 30px;
    width: calc(100% - 2px);
    border-radius: 20px;
    outline: none;
    // border: none;
    text-indent: 38px;
    font-size: 14px;
    border:1px solid #F9591B;
    -webkit-appearance: none;//input去掉自带的内阴影
  }
  .search-icon{
    width: 16px;
    height: 16px;
    display: inline-block;
    position: absolute;
    // top: 32%;
    top:14px;
    left: 14px;
    transform: translateY(-50%);
    img {
      width: 100%;
      height: 100%;
    }
  }
  .search-btn{
    display: inline-block;
    width: 60px;
    height: 32px;
    background: linear-gradient(118deg, #FF981F 0%, #F9591B 100%);
    border-radius: 18px;
    font-weight: 400;
    color: #FFFFFF;
    font-size: 15px;
    text-align: center;
    line-height: 32px;
    position: absolute;
    top:13px;
    right: 0px;
  }
  .search-btns{
    display: inline-block;
    width: 60px;
    height: 37px;
    background: linear-gradient(118deg, #FF981F 0%, #F9591B 100%);
    border-radius: 18px;
    font-weight: 400;
    color: #FFFFFF;
    font-size: 15px;
    text-align: center;
    line-height: 37px;
    position: absolute;
    top:7px;
    right: 0px;
  }
}
 .condition {
    padding: 0 12px 2px;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    // position: fixed;
    // top: 88px;
    // left: 0;
    background: #fff;
    z-index: 99;
    .tag {
      font-size: 14px;
      color: #666666;
      width: 26.667%;
      line-height: 20px;
      background: #f5f6f7;
      border-radius: 3px;
      padding-top: 5px;
      padding-bottom: 5px;
      margin-right: 6px;
      text-align: center;
      &.tag-active {
        background: rgba(249, 89, 27, 0.1);
        color: #F9591B;
      }
      &:nth-of-type(3) {
        width: 42.067%;
      }
    }
  }
}
</style>
